import React, { useState, useEffect } from 'react';
import { api, endpoints } from '../config/api';
import './SystemNotifications.css';
import { useT } from '../i18n';

const messages = {
  title: { tr: '🔔 Sistem Uyarıları', en: '🔔 System Notices' },
  empty: { tr: 'Aktif sistem uyarısı yok.', en: 'No active system notices.' },
  markRead: { tr: 'Okundu olarak işaretle', en: 'Mark as read' },
  showLess: { tr: 'Daha Az Göster', en: 'Show Less' },
  showMore: { tr: '{n} Tane Daha Göster', en: 'Show {n} More' },
};

function SystemNotifications({ showAll: showAllProp = false, hideIfEmpty = true }) {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(showAllProp);
  const { t, formatDate } = useT(messages);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const data = await api.get(endpoints.admin.notifications.user);
      console.log('📬 Notifications API Response:', data);
      console.log('📨 Unread notifications:', data.unread);
      console.log('📊 Unread count:', data.unread_count);
      setNotifications(data.unread || []);
      setUnreadCount(data.unread_count || 0);
    } catch (err) {
      console.error('❌ Error fetching notifications:', err);
      console.error('Error details:', err.response?.data);
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (notificationId) => {
    try {
      await api.post(endpoints.admin.notifications.markRead(notificationId));
      // Remove from unread list
      setNotifications(prev => prev.filter(n => n.id !== notificationId));
      setUnreadCount(prev => Math.max(0, prev - 1));
    } catch (err) {
      console.error('Error marking notification as read:', err);
    }
  };

  const getTypeIcon = (type) => {
    switch(type) {
      case 'info': return 'ℹ️';
      case 'warning': return '⚠️';
      case 'error': return '❌';
      case 'success': return '✅';
      default: return '📢';
    }
  };

  const getTypeClass = (type) => {
    return `notification-${type}`;
  };

  if (loading) {
    return hideIfEmpty ? null : (
      <div className="system-notifications">
        <div className="notifications-header">
          <h3>{t('title')}</h3>
        </div>
        <div style={{ padding: '24px', textAlign: 'center', color: '#6b7280' }}>
          {t('loading')}
        </div>
      </div>
    );
  }

  if (notifications.length === 0) {
    return hideIfEmpty ? null : (
      <div className="system-notifications">
        <div className="notifications-header">
          <h3>{t('title')}</h3>
        </div>
        <div style={{ 
          padding: '24px', 
          background: '#f9fafb', 
          borderRadius: '8px', 
          textAlign: 'center',
          color: '#6b7280'
        }}>
          {t('empty')}
        </div>
      </div>
    );
  }

  const displayedNotifications = showAll ? notifications : notifications.slice(0, 3);

  return (
    <div className="system-notifications">
      <div className="notifications-header">
        <h3>
          {t('title')}
          {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
        </h3>
      </div>
      
      <div className="notifications-list">
        {displayedNotifications.map(notification => (
          <div 
            key={notification.id} 
            className={`notification-item ${getTypeClass(notification.notification_type)}`}
          >
            <div className="notification-icon">
              {getTypeIcon(notification.notification_type)}
            </div>
            <div className="notification-content">
              <div className="notification-title">{notification.title}</div>
              <div className="notification-message">{notification.message}</div>
              <div className="notification-meta">
                {formatDate(notification.created_at, {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric'
                })}
              </div>
            </div>
            <button 
              className="notification-close"
              onClick={() => markAsRead(notification.id)}
              title={t('markRead')}
            >
              ×
            </button>
          </div>
        ))}
      </div>

      {notifications.length > 3 && (
        <button 
          className="show-more-btn"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? t('showLess') : t('showMore', { n: notifications.length - 3 })}
        </button>
      )}
    </div>
  );
}

export default SystemNotifications;
